<template>
            <footer class="footer">
      <div class="container">
        <nav class="float-left">
          <ul>
            <li>
              <a href="/">
                Tendai Events
              </a>
            </li>
            <li>
              <a href="/about">
                About Us
              </a>
            </li>
            <!-- <li>
              <a href="https://www.creative-tim.com/blog">
                Blog
              </a>
            </li>
            <li>
              <a href="https://www.creative-tim.com/license">
                Licenses
              </a>
            </li> -->
          </ul>
        </nav>
        <div class="copyright float-right">
          
          made with <i class="material-icons">favorite</i> by
          <a href="https://open.engineer/johnkyony" target="_blank"> John Kyony</a> for a better web.
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    name: 'loginFooter'
}
</script>